import getGeneralImage from '../getGeneralImage';

/**
 * @function getTileImage -Function to get relevent tile images
 * @param {*} props - Strapi Data
 * @returns {string} - Responsive images based on desktop,mobile and tablet view
 */
export const getTileImage = props => {
    const infoTileMobile = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Info_Tile_Images,
            key: 'tileBackground',
            view: 'MobileViewImage',
        }).url
    }`;
    const infoTileTablet = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Info_Tile_Images,
            key: 'tileBackground',
            view: 'TabletViewImage',
        }).url
    }`;
    const infoTileDesktop = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Info_Tile_Images,
            key: 'tileBackground',
            view: 'DesktopViewImage',
        }).url
    }`;
    const infoTileForegroundDesktop = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Info_Tile_Images,
            key: 'tileForeground',
            view: 'DesktopViewImage',
        }).url
    }`;
    const infoTileForegroundTablet = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Info_Tile_Images,
            key: 'tileForeground',
            view: 'TabletViewImage',
        }).url
    }`;
    const infoTileForegroundMobile = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Info_Tile_Images,
            key: 'tileForeground',
            view: 'MobileViewImage',
        }).url
    }`;
    return {
        infoTileMobile,
        infoTileDesktop,
        infoTileTablet,
        infoTileForegroundDesktop,
        infoTileForegroundMobile,
        infoTileForegroundTablet,
    };
};
